import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box
} from '@mui/material';

interface UserData {
  nombre: string;
  plan: string;
  dni: string;
  direccion: string;
  fecha_nacimiento: string;
}

interface UsersModalProps {
  open: boolean;
  onClose: () => void;
  users: { [key: string]: UserData };
}

const UsersModal: React.FC<UsersModalProps> = ({ open, onClose, users }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '28px',
          boxShadow: 'none',
          background: '#fff',
          border: '1px solid #b3b3b3',
          minWidth: 600,
          
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, pt: 2, pb: 0 }}>
        <Typography variant="h6" sx={{ fontWeight: 400, color: '#222', fontSize: 20 }}>
          Usuarios
        </Typography>
        <IconButton onClick={onClose} size="small" sx={{ color: '#888' }}>
          ✕
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 2, pt: 1 }}>
        <TableContainer component={Paper} sx={{ boxShadow: 'none', border: 'none', borderRadius: 0 }}>
          <Table size="small" sx={{ borderCollapse: 'collapse' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderBottom: '1px solid #b3b3b3', fontWeight: 400, color: '#222', fontSize: 18 }}>ID</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #b3b3b3', fontWeight: 400, color: '#222', fontSize: 18 }}>Nombre</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #b3b3b3', fontWeight: 400, color: '#222', fontSize: 18 }}>Plan</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #b3b3b3', fontWeight: 400, color: '#222', fontSize: 18 }}>DNI</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #b3b3b3', fontWeight: 400, color: '#222', fontSize: 18 }}>Dirección</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #b3b3b3', fontWeight: 400, color: '#222', fontSize: 18 }}>
                  Fecha de<br />nacimiento
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(users).map(([numeroAfiliado, userData]) => (
                <TableRow key={numeroAfiliado} sx={{ height: 48 }}>
                  <TableCell sx={{ borderBottom: 'none', color: '#222', fontWeight: 400, py: 2 }}>{numeroAfiliado}</TableCell>
                  <TableCell sx={{ borderBottom: 'none', color: '#222', fontWeight: 400, py: 2 }}>{userData.nombre}</TableCell>
                  <TableCell sx={{ borderBottom: 'none', color: '#222', fontWeight: 400, py: 2 }}>{userData.plan}</TableCell>
                  <TableCell sx={{ borderBottom: 'none', color: '#222', fontWeight: 400, py: 2 }}>{userData.dni}</TableCell>
                  <TableCell sx={{ borderBottom: 'none', color: '#222', fontWeight: 400, py: 2 }}>{userData.direccion}</TableCell>
                  <TableCell sx={{ borderBottom: 'none', color: '#222', fontWeight: 400, py: 2 }}>{userData.fecha_nacimiento}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default UsersModal; 